<template>
  <div id="global-uploader">
    <uploader
      :autoStart="false"
      :fileStatusText="simpleUploader.fileStatusText"
      :options="simpleUploader.options"
      :key="simpleUploader.uploaderKey"
      @file-success="onFileSuccess"
      @file-added="onFileAdded"
      @files-added="onFilesAdded"
      @file-error="onFileError"
      class="uploader-example"
      ref="uploader"
    >
      <uploader-unsupport></uploader-unsupport>

      <!-- select file -->
      <uploader-btn
        class="global-uploader-btn"
        :attrs="simpleUploader.attrs"
        ref="uploadFileBtn"
      />

      <!-- select folder -->
      <uploader-btn
        class="global-uploader-btn"
        :directory="true"
        ref="uploadFolderBtn"
      />

      <uploader-list v-show="uploaderPanelShow">
        <div
          class="file-panel"
          slot-scope="props"
          :class="{'collapse': collapse}"
        >
          <div class="file-title">
            <p class="file-list-title">文件列表</p>
            <div class="operate">
              <el-button
                type="text"
                @click="operate"
                :title="collapse ? '折叠':'展开' "
              >
                <i
                  class="icon"
                  :class="collapse ? 'el-icon-caret-bottom': 'el-icon-caret-top'"
                ></i>
              </el-button>
              <el-button
                type="text"
                @click="close"
                title="关闭"
              >
                <i class="icon el-icon-close"></i>
              </el-button>
            </div>
          </div>

          <ul
            class="file-list"
            :class="collapse ? 'uploader-list-ul-show': 'uploader-list-ul-hidden'"
          >
            <li
              v-for="file in props.fileList"
              :key="file.id"
            >
              <uploader-file
                :class="'file_' + file.id"
                ref="files"
                :file="file"
                :list="true"
              ></uploader-file>
            </li>
            <div
              class="no-file"
              v-if="!props.fileList.length"
            ><i class="icon icon-empty-file"></i> 暂无待上传文件
            </div>
          </ul>

        </div>
      </uploader-list>

    </uploader>
  </div>
</template>

<script>
import Bus from './js/bus'
import merge from 'lodash/merge'
import cloneDeep from 'lodash/cloneDeep'
import { nanoid } from 'nanoid'

const ignoredFileList = ['.DS_Store']
const chunkSize = 5 * 1024 * 1024
// 文档：https://github.com/simple-uploader/vue-uploader/blob/master/README_zh-CN.md
// 文档：https://github.com/simple-uploader/Uploader/blob/develop/README_zh-CN.md
// 示例：https://www.cnblogs.com/xiahj/p/vue-simple-uploader.html
export default {
  name: 'globalUploader',
  data() {
    return {
      // 选择文件后，展示上传panel
      uploaderPanelShow: false,
      collapse: true,
      /**
       * 初始化组件 vue-simple-uploader
       */
      simpleUploader: {
        // 这个用来刷新组件--解决不刷新页面连续上传的缓存上传数据（注：每次上传时，强制这个值进行更改---根据自己的实际情况重新赋值）
        uploaderKey: new Date().getTime(),
        // 组件实例化时传入的配置项
        options: {
          // 目标上传 URL，可以是字符串也可以是函数，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk 以及是否是测试模式
          target: '/api/file/open/upload/files/sliceUpload',
          // 分块时按照该值来分，最后一个上传块的大小是可能是大于等于1倍的这个值但是小于两倍的这个值大小
          chunkSize: chunkSize,
          allowDuplicateUploads: true,
          query: (file, chunks) => {
            return {
              identifier: file.identifier
            }
          },
          testChunks: false,
          // 测试的时候使用的 HTTP 方法，可以是字符串或者函数，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk
          testMethod: 'POST',
          // 真正上传的时候使用的 HTTP 方法，可以是字符串或者函数，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk
          uploadMethod: 'POST',
          initialPaused: false,
          // 用于格式化你想要剩余时间，一般可以用来做多语言
          parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {
            // timeRemaining{Number}, 剩余时间，秒为单位
            // parsedTimeRemaining{String}, 默认展示的剩余时间内容
            return parsedTimeRemaining
              .replace(/\syears?/, '年')
              .replace(/\days?/, '天')
              .replace(/\shours?/, '小时')
              .replace(/\sminutes?/, '分钟')
              .replace(/\sseconds?/, '秒')
          }
        },
        // 用于转换文件上传状态文本映射对象
        fileStatusText: function (status, response) {
          // 第一个 status 为状态，第二个为响应内容
          const statusTextMap = {
            success: '成功',
            error: '失败',
            uploading: '上传中',
            paused: '暂停',
            waiting: '等待'
          }
          return statusTextMap[status]
        },
        // 添加到 input 元素上的额外属性
        attrs: {}
      },
      propsfileList: [],
      fileType: 1, // 1是文件夹 2是文件
      fileParentId: 0,
      // 机构文件上传
      orgParams: {
        // orgId: '', // 数据示例，本注释请不要删除 上传机构id
        // parentOrgFileId: '' // 数据示例，本注释请不要删除 上级文件id 基础的就给空
      },
      panelShow: false,   //选择文件后，展示上传panel
      tempNanoidList: [] // 临时存储已经合并过的文件的唯一ID
    }
  },
  computed: {
    uploaderInstance() {
      return this.$refs.uploader.uploader
    }
  },
  created() {
    this.tempNanoidList = []
  },
  activated() {

  },
  // 钩子函数：页面加载完成后执行
  mounted: function () {
    Bus.$on('openUploader', ({ params = {}, options = {} }) => {
      this.orgParams = this.hasOrgId(params) ? cloneDeep(params) : {}

      if (params.evt === 1) {
        this.openFileUploader()
        this.fileType = 2
        this.fileParentId = params.fileParentId
      } else if (params.evt === 2) {
        this.openFolderUploader()
        this.fileType = 1
        this.fileParentId = params.fileParentId
      } else if (params.evt === 4) {
        this.uploaderPanelShow = false
      } else {
        this.uploaderPanelShow = true
      }
    })
  },
  methods: {
    addTempNanoidList(id) {
      this.tempNanoidList.push(id)
    },
    /**
     * 触发文件上传的按钮
     */
    openFileUploader: function () {
      this.$refs.uploadFileBtn?.$el.click()
    },

    /**
     * 触发文件夹上传的按钮
     */
    openFolderUploader: function () {
      this.$refs.uploadFolderBtn?.$el.click()
    },

    /**
     * 折叠、展开面板动态切换
     */
    operate: function () {
      this.collapse = !this.collapse
    },

    /**
     * 关闭折叠面板
     */
    close() {
      this.uploaderPanelShow = false
    },

    /**
     * 事件
     * 一个文件上传成功
     *
     * @param {object} rootFile 成功上传的文件所属的根 Uploader.File 对象，它应该包含或者等于成功上传文件
     * @param {object} file 当前成功的 Uploader.File 对象本身
     * @param {object} message 服务端响应内容，永远都是字符串
     * @param {object} chunk Uploader.Chunk 实例，它就是该文件的最后一个块实例，如果你想得到请求响应码的话，chunk.xhr.status 就是
     */
    async onFileSuccess(rootFile, file, message, chunk) {
      try {
        const response = JSON.parse(message)
        if (response.code === 20000) {
          const { code, data } = await this.$fetch('/api/file/open/upload/files/sliceAssemble/' + file.identifier, {})

          if (code === 20000) {
            const { serviceFileName } = data

            file._fileSuffix = serviceFileName && serviceFileName.split('/').pop().split('.').pop()
            file._fileUrl = serviceFileName

            this.addTempNanoidList(file._nanoid)
          }

          // 单次全部上传完毕
          // 同一批的_nanoid
          // 未合并过
          if (!file._merge && this.tempNanoidList.filter(id => id === file._nanoid).length === file._count) {
            const temp = rootFile.files.length > 0 ? rootFile.files.filter(item => item._nanoid === file._nanoid) : rootFile.uploader.files.filter(item => item._nanoid === file._nanoid)
            // 文件切片合并状态改为已合并
            for (let item of temp) {
              item._merge = true
            }
            if (rootFile.files.length > 0) {
              this.postInsertMultiFile(temp)
            } else {
              this.postInsertSingleFile(temp)
            }
          }
        }
      } catch (err) {
      }
    },
    onFileAdded(file) {
      // 文件过滤
      file.ignored = ignoredFileList.findIndex(item => item === file.name) !== -1
    },

    /**
     * 事件
     * 和 fileAdded 一样，但是一般用作多个文件的校验。
     */
    async onFilesAdded(files, fileList, event) {
      const totalSize = files.reduce((acc, item) => acc + item.size, 0)
      const size = 50 * 1024 * 1024
      // 标记这是一起选择的文件
      const _nanoid = nanoid()

      for (let file of files) {
        file.pause()
      }

      if (totalSize > size) {
        this.$message.error('所选文件超过50M,请分批次上传')
        this.uploaderInstance.cancel()
        return
      }
      if (files.length > 20) {
        this.$message.error('所选文件超过20条，请分批次上传')
        this.uploaderInstance.cancel()
        return
      }

      const arrIdentifier = files.map(item => this.$fetch('/api/file/open/upload/files/sliceInit', { originalFileName: item.name }))

      try {
        const res = await Promise.all(arrIdentifier)
        for (let i = 0; i < files.length; i++) {
          if (res[i].code === 20000) {
            // 文件切片合并状态改
            files[i]._merge = false
            // 同一批次上传文件的唯一标识
            files[i]._nanoid = _nanoid
            // 同一批次上传文件的总个数
            files[i]._count = files.length
            files[i].identifier = res[i].data
            files[i].resume()
          } else {
            this.uploaderInstance.removeFile(files[i])
          }
        }
      } catch (err) {
      }

      this.uploaderPanelShow = true
    },

    /**
     * 事件
     * 文件上传出错 todo 代码优化
     */
    onFileError: function (rootFile, file, message, chunk) {

    },

    // 是机构上传
    hasOrgId(obj) {
      return Object.prototype.toString.call(obj) === '[object Object]' && Object.prototype.hasOwnProperty.call(obj, 'orgId') && !!obj.orgId
    },
    // 新增文件或者空文件夹
    async postInsertMultiFile(arr) {
      const api = this.hasOrgId(this.orgParams) ? '/api/file-cloud/org_file/insert_org_list_file_and_package' : '/api/file-cloud/user_file/insert_user_list_file_and_package'
      const paramsList = arr.map(item => {
        const _item = {
          fileParentId: this.fileParentId,
          filePath: item.relativePath,
          fileType: item.isFolder ? 1 : 2,
          fileName: item.name,
          fileSize: item.size,
          fileSuffix: item._fileSuffix,
          fileUrl: item._fileUrl
        }

        return this.hasOrgId(this.orgParams) ? merge(_item, this.orgParams) : _item
      })

      const { code } = await this.$fetch(api, paramsList)
      if (code === 20000) {
        Bus.$emit('fileSuccess')
      }
    },
    // 新增文件或者空文件夹
    async postInsertSingleFile(arr) {
      const api = this.hasOrgId(this.orgParams) ? '/api/file-cloud/org_file/insert_org_single_file_or_package' : '/api/file-cloud/user_file/insert_user_single_file_or_package'
      const paramsList = arr.map(item => {
        const _item = {
          fileParentId: this.fileParentId,
          fileType: item.isFolder ? 1 : 2,
          fileName: item.name,
          fileSize: item.size,
          fileSuffix: item._fileSuffix,
          fileUrl: item._fileUrl
        }

        return this.hasOrgId(this.orgParams) ? merge(_item, this.orgParams) : _item
      })

      if (paramsList.length < 1) {
        return
      }

      try {
        const res = await Promise.all(paramsList.map(item => this.$fetch(api, item)))
        if (res.some(item => item.code === 20000)) {
          Bus.$emit('fileSuccess')
        }
      } catch (err) {}
    }
  }
}
</script>

<style lang="scss" scoped>
#global-uploader {
  position: fixed;
  z-index: 20;
  right: 15px;
  bottom: 15px;
  width: 550px;
}

.file-panel {
  background-color: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 7px 7px 0 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.file-title {
  display: flex;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  border-bottom: 1px solid #ddd;
}

.file-title {
  background-color: #e7ecf2;
}

.uploader-file-meta {
  display: none !important;
}

.operate {
  flex: 1;
  text-align: right;
}

.file-list {
  position: relative;
  height: 240px;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fff;
  padding: 0px;
  margin: 0 auto;
  transition: all 0.5s;
}

.uploader-file-size {
  width: 15% !important;
}

.uploader-file-status {
  width: 32.5% !important;
  text-align: center !important;
}

li {
  background-color: #fff;
  list-style-type: none;
}

.no-file {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
}

/* 隐藏上传按钮 */
.global-uploader-btn {
  display: none !important;
  clip: rect(0, 0, 0, 0);
  /* width: 100px;
  height: 50px; */
}

.file-list-title {
  /*line-height: 10px;*/
  font-size: 16px;
}

.uploader-file-name {
  width: 36% !important;
}

.uploader-file-actions {
  float: right !important;
}

.uploader-list-ul-hidden {
  height: 0px;
}
</style>

